let CartAbandonmentReport = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.reports();
    },

    reports: function () {
        let reportsForm = $('#cartAbandonmentForm');
        let submitBtn = Ladda.create(reportsForm.find('[type=submit]')[0]);

        reportsForm.ajaxForm({
            beforeSubmit: function () {
                submitBtn.start();
            },

            success: function (response) {
                if (response.success) {
                    $('#cartsTableContainer').html(response.content);
                    DataTables.carts();
                } else {
                    toastr.error(response.error.message);
                }
                submitBtn.stop();
            },

            error: function (response) {
                toastr.error(response.responseJSON.error.message);
                submitBtn.stop();
            }
        });
    }
};


$().ready(function () {
    window.CartAbandonmentReport = CartAbandonmentReport;
    window.CartAbandonmentReport.init();
});
